import { TableItem } from 'components/atoms';
import { Table } from 'components/organisms';
import { useParamId } from 'hooks/useParamId';
import { useTranslation } from 'react-i18next';
import { getNodes } from 'utils/table/nodes.utils';
import { useGetSalesChannelProviders } from 'services/salesChannel';
import { IMusicPlatform } from 'services/salesChannel/types';
import { Button } from 'components/atoms';
import { PiNavigationArrow } from 'react-icons/pi';
import { usePermissionGuard } from 'hooks/usePermissionGuard';

const Providers = () => {
 const urlId = useParamId('settings/sales-channel');
 usePermissionGuard('ProvidersPermissionsLIST**');


 const { t } = useTranslation();

 const { data, isLoading } = useGetSalesChannelProviders(urlId);

 const tableData = getNodes<IMusicPlatform>(
  Array.isArray(data) ? data : data ? [data] : []
 );

 return (
  <Table
   size="compact"
   data={tableData}
   loading={isLoading}
   columns={[
    {
     label: t('input.label.name'),
     renderCell: ({ name }) => (
      <TableItem>
       <TableItem.Text text={name} />
      </TableItem>
     ),
     resize: true,
    },

    {
     label: '',
     renderCell: (item) => (
      <TableItem justifyPosition="end">
       <Button
        isClear
        onlyIcon
        onClick={() => window.open(`/settings/provider/${item.id}`)}
       >
        <Button.Icon icon={<PiNavigationArrow transform="scale(-1,1)" />} />
       </Button>
      </TableItem>
     ),
    },
   ]}
  />
 );
};

export default Providers;
